var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreySugar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.446,
    xmlns: "http://www.w3.org/2000/svg",
    height: 300.446,
    id: "screenshot-1d8af7ff-090f-80c0-8002-992170be1968",
    viewBox: "-0.223 -0.223 300.446 300.446",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-992170be1968",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-992170be1969",
    height: 48,
    width: 48,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-992170be1973"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-992170be1973"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M150.269,275.000C133.033,275.025,116.830,271.768,101.661,265.228C86.491,258.688,73.221,249.750,61.850,238.412C50.479,227.075,41.501,213.824,34.916,198.658C28.331,183.493,25.026,167.283,25.000,150.030C24.974,132.776,28.231,116.556,34.771,101.372C41.311,86.187,50.250,72.961,61.587,61.694C72.925,50.427,86.176,41.501,101.342,34.916C116.507,28.331,132.717,25.026,149.970,25.000C167.224,24.974,183.444,28.231,198.628,34.771C213.813,41.311,227.039,50.198,238.306,61.431C249.573,72.664,258.499,85.880,265.084,101.079C271.669,116.277,274.974,132.495,275.000,149.731C275.025,166.967,271.768,183.170,265.228,198.339C258.688,213.509,249.802,226.760,238.569,238.092C227.335,249.425,214.120,258.403,198.921,265.026C183.723,271.650,167.505,274.974,150.269,275.000ZL150.269,275.000ZM150.314,256.250C179.793,256.206,204.830,245.804,225.424,225.044C246.018,204.284,256.293,179.165,256.250,149.686C256.206,120.207,245.876,95.170,225.259,74.576C204.643,53.981,179.503,43.706,149.842,43.750C120.467,43.794,95.430,54.124,74.732,74.741C54.033,95.357,43.706,120.497,43.750,150.158C43.794,179.533,54.196,204.570,74.956,225.268C95.716,245.966,120.835,256.293,150.314,256.250ZL150.314,256.250ZM150.000,150.000L150.000,150.000Z",
    style: {
      fill: "rgb(87, 107, 124)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-9921c53dfac5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-9921c53dfac5"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M142.319,214.492L142.319,153.152L88.694,122.184L88.694,183.524L142.319,214.492ZL142.319,214.492ZM154.236,214.492L207.861,183.524L207.861,121.986L154.236,153.120L154.236,214.492ZL154.236,214.492ZM148.277,143.028L201.108,112.259L148.277,81.688L95.248,112.259L148.277,143.028ZL148.277,143.028ZM82.736,193.847C80.849,192.732,79.384,191.262,78.341,189.437C77.299,187.613,76.777,185.642,76.777,183.524L76.777,116.030C76.777,113.913,77.299,111.942,78.341,110.117C79.384,108.293,80.849,106.823,82.736,105.708L142.319,71.365C144.216,70.307,146.213,69.777,148.310,69.777C150.407,69.777,152.382,70.307,154.236,71.365L213.819,105.708C215.706,106.823,217.170,108.293,218.213,110.117C219.256,111.942,219.777,113.913,219.777,116.030L219.777,183.524C219.777,185.642,219.256,187.613,218.213,189.437C217.170,191.262,215.706,192.732,213.819,193.847L154.236,228.189C152.338,229.248,150.341,229.777,148.245,229.777C146.148,229.777,144.173,229.248,142.319,228.189L82.736,193.847ZL82.736,193.847ZM148.277,149.777L148.277,149.777Z",
    style: {
      fill: "rgb(87, 107, 124)",
      fillOpacity: 1
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreySugar);
export default __webpack_public_path__ + "static/media/grey_sugar.940002ce3938ec652bf6ed6013274bea.svg";
export { ForwardRef as ReactComponent };